import apiClient from '.';

const updateAdditionalInfo = async (params: Record<string, any>) => {
    const { data }: any = await apiClient.post('remarks', {
        data: params,
    });
    if (data.error) {
        throw {
            error: data?.error,
        };
    }
    return data;
};

export { updateAdditionalInfo };
